import { getIcon } from '../../../../shared/utils/icon-helper';
import { ManualType } from '../documents-helper';

export const getDocumentIconByManualType = (type: ManualType): JSX.Element => {
	if (type === ManualType.video) return getIcon('video', 30);
	if (type === ManualType.svg) return getIcon('image-file', 30);
	return getIcon('pdf', 30);
};
